import React, { Component } from 'react';

class ShikokuTop extends Component {
  render() {
    return (
      <div className="Shikoku-top pref">
        <div>愛媛</div>
        <div>香川</div>
      </div>
    );
  }
}
class ShikokuBot extends Component {
  render() {
    return (
      <div className="Shikoku-bot pref">
        <div>高知</div>
        <div>徳島</div>
      </div>
    );
  }
}


class Shikoku extends Component {

  render() {

    return (
      <div className="Shikoku">
        <ShikokuTop />
        <ShikokuBot />
      </div>
    );
  }

}

export default Shikoku;
